module.exports = __webpack_public_path__ + "static/img/logo-cn.d3735ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-cn.png
// module id = S6Q/
// module chunks = 13